module.exports = __webpack_public_path__ + "img/logo.199acce8.png";